import client from "~/apis/client"

// { unread_count, notifications }
export function fetchNotifications() {
  return client.get("/notifications")
}

export function markAllNotificationsRead() {
  return client.patch("/notifications/read_all")
}

export function markNotificationRead(id) {
  return client.patch(`/notifications/${id}/read`)
}
